
export const QARSHI_BOUNDARY_COORDS: [number, number][] = [
  [38.8627352, 65.7539566], 
  [38.8829661, 65.7495019], 
  [38.9085078, 65.7531483], 
  [38.9265480, 65.7706149], 
  [38.9228672, 65.7872821], 
  [38.9253769, 65.8026589], 
  [38.9227836, 65.8164228], 
  [38.9237432, 65.8224770], 
  [38.9170583, 65.8417001], 
  [38.9084464, 65.8574282], 
  [38.9038000, 65.8628164], 
  [38.8914461, 65.8635446], 
  [38.8836925, 65.8686124], 
  [38.8804050, 65.8697775], 
  [38.8740562, 65.8655542], 
  [38.8632846, 65.8616222], 
  [38.8624908, 65.8606028], 
  [38.8712795, 65.8629724],
  [38.8672541, 65.8623939],
  [38.8662517, 65.8620881],
  [38.8648695, 65.8613406],
  [38.8628798, 65.8602856],
  [38.8616121, 65.8596154],
  [38.8612583, 65.8593875],
  [38.8597145, 65.8582877],
  [38.8573034, 65.8565924],
  [38.8540083, 65.8543506],
  [38.8524372, 65.8532368],
  [38.8513897, 65.8525152],
  [38.8508441, 65.8522350],
  [38.8495293, 65.8515555],
  [38.8485199, 65.8510441],
  [38.8481288, 65.8508400],
  [38.8460794, 65.8497295],
  [38.8454025, 65.8493995],
  [38.8440048, 65.8485948],
  [38.8425570, 65.8478545],
  [38.8418613, 65.8474682],
  [38.8413531, 65.8472436],
  [38.8411185, 65.8470404],
  [38.8408948, 65.8465571],
  [38.8403655, 65.8455763],
  [38.8401309, 65.8449458],
  [38.8399726, 65.8442733],
  [38.8391978, 65.8423328],
  [38.8386085, 65.8405744],
  [38.8382811, 65.8395586],
  [38.8377720, 65.8400056],
  [38.8371481, 65.8405092],
  [38.8366845, 65.8406465],
  [38.8358466, 65.8404863],
  [38.8353652, 65.8400056],
  [38.8347234, 65.8388841],
  [38.8340459, 65.8384492],
  [38.8343489, 65.8401430],
  [38.8331722, 65.8411958],
  [38.8324947, 65.8418138],
  [38.8318707, 65.8409440],
  [38.8294815, 65.8421113],
  [38.8280372, 65.8395021],
  [38.8278232, 65.8391130],
  [38.8281798, 65.8390672],
  [38.8276093, 65.8352449],
  [38.8274488, 65.8337572],
  [38.8273061, 65.8334367],
  [38.8271100, 65.8301408],
  [38.8251307, 65.8296831],
  [38.8227413, 65.8290651],
  [38.8236897, 65.8241333],
  [38.8230925, 65.8238316],
  [38.8217621, 65.8231302],
  [38.8208024, 65.8229229],
  [38.8195860, 65.8231363],
  [38.8190918, 65.8233559],
  [38.8180227, 65.8239718],
  [38.8177614, 65.8241347],
  [38.8158616, 65.8252384],
  [38.8142189, 65.8262523],
  [38.8127579, 65.8271294],
  [38.8110147, 65.8282158],
  [38.8100365, 65.8286584],
  [38.8098923, 65.8288193],
  [38.8097293, 65.8289883],
  [38.8095788, 65.8290527],
  [38.8094702, 65.8290190],
  [38.8094897, 65.8284374],
  [38.8095057, 65.8269311],
  [38.8093670, 65.8252468],
  [38.8092976, 65.8238569],
  [38.8092016, 65.8232886],
  [38.8091055, 65.8217002],
  [38.8090949, 65.8195777],
  [38.8049133, 65.8196188],
  [38.8049668, 65.8174444],
  [38.8023920, 65.8161805],
  [38.8023091, 65.8161398],
  [38.8018810, 65.8163229],
  [38.8015064, 65.8165518],
  [38.8010070, 65.8167806],
  [38.8014173, 65.8146978],
  [38.7984205, 65.8137136],
  [38.7850000, 65.8100000],
  [38.7850000, 65.7900000],
  [38.7750000, 65.7850000],
  [38.7600000, 65.7750000],
  [38.7600000, 65.7600000],
  [38.7650000, 65.7550000],
  [38.7750000, 65.7500000],
  [38.7850000, 65.7460000],
  [38.7950000, 65.7430000],
  [38.8050000, 65.7400000],
  [38.8137436, 65.7383933],
  [38.8243242, 65.7335392],
  [38.8263178, 65.7331847],
  [38.8277823, 65.7329484],
  [38.8304634, 65.7323264],
  [38.8312470, 65.7319240],
  [38.8331379, 65.7309531],
  [38.8349228, 65.7298402],
  [38.8353219, 65.7309112],
  [38.8357587, 65.7347106],
  [38.8344928, 65.7348937],
  [38.8354645, 65.7433280],
  [38.8361625, 65.7501490],
  [38.8364477, 65.7512018],
  [38.8369648, 65.7524607],
  [38.8378740, 65.7538111],
  [38.8385515, 65.7542460],
  [38.8407086, 65.7553904],
  [38.8459140, 65.7577707],
  [38.8477501, 65.7580454],
  [38.8487305, 65.7578165],
  [38.8489266, 65.7584345],
  [38.8588190, 65.7557566],
  [38.8687457, 65.7530100],
  [38.8689239, 65.7548410],
  [38.8627352, 65.7539566],
];
export function isPointInPolygon(
  point: [number, number],
  polygon: [number, number][]
): boolean {
  const [lat, lon] = point;
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0],
      yi = polygon[i][1];
    const xj = polygon[j][0],
      yj = polygon[j][1];

    const intersect =
      yi > lon !== yj > lon &&
      lat < ((xj - xi) * (lon - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
}
